import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

import Chat from "components/base/Chat";
import { Tooltip, TooltipName } from "components/base/Tooltip";
import { media } from "components/styles/breakpoints";
import { getFightStatus } from "redux/selectors/fightSelectors";
import { viewFullComms } from "redux/actions";

const MiniChatWrapper = styled.div<{ isFighting: boolean }>`
  position: absolute;
  bottom: 3dvh;
  left: 3dvh;
  z-index: 6;
  border-radius: 4px;

  background-color: #00000080;
  backdrop-filter: blur(20px);

  max-width: 300px;
  height: 100px;
  display: none;
  flex-direction: column;

  ${({ isFighting }) => !isFighting && `display: flex;`}
  // Hide chat when fighting only for mobile

  ${media.desktop`
    bottom: 5dvh;
    left: 5dvh;
    max-width: 400px;
    height: 160px;
    display: flex;
  `}
`;

const ExpandButton = styled.div`
  position: absolute;
  top: 1px;
  right: 1px;
  z-index: 2;
  cursor: pointer;
  border-left: 1px solid #43fffa40;
  border-bottom: 1px solid #43fffa40;
  border-radius: 0 4px 0 4px;
  background-color: #00000080;
  backdrop-filter: blur(20px);
`;

const ExpandIcon = styled.div`
  height: 28px;
  width: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #43fffa;
  font-size: 18px;
`;

// Reactions

export default function MiniChat() {
  const dispatch = useDispatch();

  const fightStatus = useSelector(getFightStatus);

  return (
    <MiniChatWrapper isFighting={fightStatus === "fighting"}>
      <ExpandButton
        onClick={() => {
          dispatch(viewFullComms());
        }}
      >
        <Tooltip
          content={
            <>
              <TooltipName>Expand chat</TooltipName>
            </>
          }
        >
          <ExpandIcon>↕</ExpandIcon>
        </Tooltip>
      </ExpandButton>
      <Chat />
    </MiniChatWrapper>
  );
}
